import { VehicleEquipment } from './vehicle-equipment';
import { VehicleVersionQuotes } from './vehicle-version-quotes';

export class VehicleVersion {
  make: string;
  model: string;
  mounting: string; // allestimento
  engineCapacity: string;
  infocarcodeAM: string;
  description: string;
  transmission: string;
  kilowatt: string;
  horsepower: string;

  equipments: VehicleEquipment[] = [];
  equipmentsAll: VehicleEquipment[] = [];
  quotes: VehicleVersionQuotes;

  /* Campi non provenienti dal servizio */

  productionCountry: string = 'Italia';
  effectiveKilometers: number;
  vehicleBodyStatus: number = 1;
  vehicleInternalStatus: number = 1;
  vehicleEngineStatus: number = 1;


  get kilometersDiff(): number {
    return (this.quotes.theoreticalKilometers - this.effectiveKilometers) * 0.05;
  }


  get effectiveVehicleQuote(): number {
    if (!this.effectiveKilometers || !this.quotes.sellVehicleQuote) {
      return null
    }
    const vehicleQuote = this.quotes.sellVehicleQuote;
    const bodyQuote = vehicleQuote - (MAX_STATUS_VALUE - this.vehicleBodyStatus) * 400;
    const internalQuote = vehicleQuote - (MAX_STATUS_VALUE - this.vehicleInternalStatus) * 400;
    const engineQuote = vehicleQuote - (MAX_STATUS_VALUE - this.vehicleEngineStatus) * 400;

    const finalQuote = Math.round((bodyQuote + internalQuote + engineQuote) / 3 + this.kilometersDiff);

    if (finalQuote < vehicleQuote * MAX_PERCENTAGE / 100) {
      return vehicleQuote * MAX_PERCENTAGE / 100
    } else {
      if (finalQuote > vehicleQuote + (vehicleQuote * MAX_PERCENTAGE / 100)) {
        return vehicleQuote + (vehicleQuote * MAX_PERCENTAGE / 100);
      }
      return finalQuote;
    }
  };
}

const MAX_STATUS_VALUE: number = 10;
const MAX_PERCENTAGE: number = 30;
